import _ from 'underscore';

/* eslint-disable no-undef,consistent-return,no-param-reassign */
/**
 *  Return the value corresponding to the key in the given object
 *
 *  @example
 *
 *  var myObj = {
 *    foo: { bar: 'hello, world!' }
 *  };
 *
 *    _.lookup(myObj, 'foo.bar'); // "hello, world!"
 *
 *  @param  {Object}  obj the object containing the key
 *  @param  {String}  key the key to look up
 */
_.mixin({
  lookup(obj, key, separator, arrayIndicator) {
    const isKeyArray = _.isArray(key);
    if (_.isUndefined(separator)) {
      separator = isKeyArray ? '|' : '.';
    }
    if (_.isUndefined(arrayIndicator)) {
      arrayIndicator = '$';
    }
    if (_.isUndefined(obj) || _.isUndefined(key) || _.isNull(obj) || _.isNull(key)) {
      return;
    }
    const keys = isKeyArray ? key.join(separator).split(separator) : key.split(separator);
    const cur = keys.shift();

    if (keys.length) {
      if (_.isObject(obj[cur])) {
        return _.lookup(obj[cur], keys, separator, arrayIndicator);
      } else if (cur === arrayIndicator) {
        const memo = [];
        _.each(obj, (v) => {
          const tmp = _.lookup(v, JSON.parse(JSON.stringify(keys)), separator, arrayIndicator);
          if (!_.isUndefined(tmp)) {
            memo.push(tmp);
          }
        });
        return _.isEmpty(memo) ? undefined : memo;
      }
      return undefined;
    }
    return obj[cur];
  },
});

export default _;
